import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EmbeddedViewRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {SessionService, User} from '../../core/session.service';
import {CacheQuery, LayoutQuery, LayoutService} from 'phd-akita-session';
import {filterMenuByRole, MenuItem} from '../../core/model';
import {UiQuery} from '../../shared/state/ui.query';
import {cloneDeep} from 'lodash-es';
import {UiService} from '../../shared/state/ui.service';
import {filterNil} from '@datorama/akita';

const getNameInit = (name: string): string => {
  if (name.startsWith('SHOP')) {
    return name.substring(5, 7);
  }
  return name.toUpperCase().split(' ', 2).map(s => s.substr(0, 1)).join('');
};


@Component({
  selector: 'ims-default-layout',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {

  isCollapsed;
  isCollapsed$: Observable<boolean>;
  isHide = false;
  menusItems$: Observable<MenuItem[]>;
  init: string;
  title$: Observable<string>;
  subTitle$: Observable<string>;
  loading$;
  user: User;

  @ViewChild('affixContent', {static: true, read: ViewContainerRef})
  affixContent: ViewContainerRef;
  affixHeaderRef: EmbeddedViewRef<any>;

  constructor(private sess: SessionService,
              private cache: CacheQuery,
              private svr: LayoutService,
              private qry: LayoutQuery,
              private ui: UiQuery,
              private uiSvr: UiService,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.user = this.sess.activeUser();
    this.qry.isXs$().pipe().subscribe((s) => this.isHide = s);
    this.init = getNameInit(this.user.name);
    this.menusItems$ = this.cache.select(s => s.data.menuItems)
      .pipe(filterNil, map(menus => filterMenuByRole(this.user.roles, cloneDeep(menus))));
    this.isCollapsed$ = this.qry.select(s => s.menuCollapsed)
      .pipe(tap(c => this.isCollapsed = c));
    this.title$ = this.qry.select(s => s.pageTitle);
    this.subTitle$ = this.uiSvr.subTitle$.asObservable();
    this.loading$ = this.ui.select(u => u.httpLoading).pipe(map((v) => ({isLoading: v})));

  }

  collapsedChanged(state: any) {
    this.svr.collapsedChanged(state);
  }

  signOut() {
    this.sess.signOut();
  }

  ngAfterViewInit(): void {
    this.svr.removePreloader();
  }


  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  public attachHeader(tpl: TemplateRef<any>) {
    this.affixHeaderRef = this.affixContent.createEmbeddedView(tpl);
    this.uiSvr.setSubtitle('');
  }

  public detachHeader() {
    this.affixContent.clear();
    this.affixHeaderRef.destroy();
    this.affixHeaderRef = null;
  }

  buildLink(sub: string, link: string): string[] {
    return link.startsWith('/') ? link.split('/') : ['/', sub, ...link.split('/')];
  }

  ngOnDestroy(): void {
  }

}

